<template lang="">
    <div v-if="order" class="w-full">
        <div class="card mt-4 max-w-screen-lg mx-auto">
            <Header :order="order" />
            <div v-if="isNight" class="mt-2 text-primary text-sm">
                {{ $t("main.notificatuin.nightOrder") }}
            </div>
            <ViewStepper :setOrder="setOrder" :orderStatus="orderStatus" :order="order" />

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="">
                    <ClientField direct="left" title="Ваши реквизиты Отдаю" :amount="getFieldsInfo.take.amount" :currencyName="getFieldsInfo.take.name" :currencyImage="getFieldsInfo.take.image" :currencyCode="getFieldsInfo.take.code" :fields="getFieldsInfo.take.fields" />
                </div>
                <div class="">
                    <ClientField direct="right" title="Ваши реквизиты Получаю" :amount="getFieldsInfo.give.amount" :currencyName="getFieldsInfo.give.name" :currencyImage="getFieldsInfo.give.image" :currencyCode="getFieldsInfo.give.code" :fields="getFieldsInfo.give.fields" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// Services
import OrderService from "../../services/OrderService";

// Components
import ClientField from "./ClientField.vue";
import Header from "./Header.vue";
import ViewStepper from "./ViewStepper.vue";
import { getIsNight } from "../../utils/time";
import moment from "moment";

export default {
    data() {
        return {
            order: null,
            now: new Date()
        };
    },
    components: {
        ClientField,
        Header,
        ViewStepper
    },

    computed: {
        currentHash() {
            let hash = this.$route.params?.hash;
            return hash;
        },
        isNight: getIsNight,
        getFieldsInfo() {
            return {
                take: {
                    name: this?.order?.currency?.take?.name,
                    image: this?.order?.currency?.take?.image,
                    fields: this?.order?.fields?.take,
                    amount: this?.order?.amount?.take,
                    code: this?.order?.currency?.take?.code
                },
                give: {
                    name: this?.order?.currency?.give?.name,
                    image: this?.order?.currency?.give?.image,
                    fields: this?.order?.fields?.give,
                    amount: this?.order?.amount?.give,
                    code: this?.order?.currency?.give?.code
                }
            };
        },
        orderStatus() {
            let order = this.order;
            if (!order) return;

            let status = order.status;

            if (order.status == 102 && order.isCounterpartyReceive) {
                return "counter-party-payment";
            }
            if (status == 101 && order.card && order.card.status === 101) {
                return "card-process";
            } else if (order.card && order.card.status == 103) {
                return "card-reverify";
            } else if (status == 106 && order.card && order.card.status == 103) {
                let diff = new Date(this.order.finished) - this.now;
                if (diff <= 0) {
                    return "order-reject";
                } else {
                    return "card-reverify";
                }
            } else if (status == 106 && order.card && order.card.status == 104) {
                return "card-banned";
            } else if (order.direction && order.direction.offer) {
                return "order-direction";
            } else if (status == 102) {
                return "order-payment";
            } else if (status == 103) {
                return "order-process";
            } else if (status == 104) {
                return "order-send-process";
            } else if (status == 106) {
                return "order-reject";
            } else if (status == 105) {
                return "order-resolve";
            } else {
                return "";
            }
        }
    },
    watch: {
        currentHash() {
            let hash = this.currentHash;
            // console.log(hash, "hash");

            if (!hash) {
                this.clear();
            } else {
                this.setData();
            }
        }
    },
    methods: {
        moment: moment,
        setOrder(o) {
            this.order = o;
        },
        clear() {
            // console.log("clear data");
            let hash = this?.order?.hash;
            if (!hash) return;

            let id = this?.order?._id;

            this.$socket.emit("auth_order_leave", hash);
            this.sockets.unsubscribe(`hash_update_order_${id}`);
            this.order = null;
        },
        async setData() {
            // console.log("set order data");
            try {
                let hash = this.currentHash;
                this.$socket.emit("auth_order", hash);
                let { data: order } = await OrderService.getOneByHash(hash);
                this.order = order;
                this.sockets.subscribe(`hash_update_order_${order._id}`, o => {
                    this.order = o;
                });
            } catch (e) {
                console.error("Error set order data:", e);
            }
        }
    },
    created,
    destroyed() {
        clearInterval(this.timer);
        this.clear();
    }
};

function created() {
    this.timer = setInterval(() => {
        this.now = new Date();
    }, 1000);
    let hash = this.currentHash;
    if (hash) {
        this.setData();
    }
}
</script>
<style lang="scss" scoped>
.orderPage {
    color: #656565;
    font-size: 16px;
    justify-content: center;
}

.orderPageDivider {
    background-color: #07070721;
    height: 1px;
}

.orderPageCard {
    background-color: $white;
    margin: 16px;
    // padding: 24px 32px;
    border-radius: $border-sm;
    box-shadow: 0 2px 2px -2px rgba(0, 0, 0, 0.32);
}

.orderNotifitcation {
    color: #20459b;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    padding: 12px;
    margin: 5px 18px;
}
</style>
